<template>
  <div>

    <Banner></Banner>

    <BrandsLogos></BrandsLogos>

    <About></About>

    <Visions></Visions>

    <Types></Types>

    <TypeDiv></TypeDiv>

    <Technology></Technology>

    <ServicesType></ServicesType>

    <WhyChooseUs></WhyChooseUs>

    <Portfolio></Portfolio>

    <Const></Const>
  </div>
</template>

<script>
import Banner from '../../components/MobileDevelopment/ARDevelopment/Banner.vue'
import ServicesType from '../../components/MobileDevelopment/IosDevelopment/ServicesType.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/MobileDevelopment/ARDevelopment/About.vue'
import Technology from '../../components/MobileDevelopment/ARDevelopment/Technology.vue'
import WhyChooseUs from '../../components/MobileDevelopment/ARDevelopment/WhyChooseUs.vue'
import Visions from '../../components/MobileDevelopment/ARDevelopment/Visions.vue'
import Types from '../../components/MobileDevelopment/ARDevelopment/Types.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        Visions,
        Types,
        TypeDiv,
        Technology,
        Portfolio,
        Const,
        WhyChooseUs,
        ServicesType
    }
}
</script>


<style>

</style>

